module.exports = __webpack_public_path__ + "media/cards/7-dc697d0e.png";